import { useDeleteProvider } from "./api/deleteProvider";
import { Button } from "reactstrap";


const DeleteProvider = ({handleCloseModal, providerId}: DeleteProviderProps)  => {
  
  const deleteProviderMutation = useDeleteProvider({ providerId});
  const handleSubmit = async (): Promise<void> => {
    deleteProviderMutation.mutateAsync({ 
      providerId: providerId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε τον Πάροχο;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteProviderProps{
  providerId: number;
  handleCloseModal: () => void;
}

export default DeleteProvider;